import { transitionDigitalSavingsPersonalDetails } from '../../../actions/digitalSavings/personalDetails';
import { getPersonalDetailsForm, getSourceOfFundsValue } from '../../../selectors/digitalSavings/personalDetails';
import { getDesiredValue, getLumpsumValue } from '@om/redux/selectors/digitalSavings/quote';
import { FIELD_STATUS } from '../../../reducers/status';

export const personalDetailsFormRules = (store, next, action) => {
    const result = next(action);
    const personalDetailsForm = getPersonalDetailsForm(store.getState());
    const sourceOfFunds = getSourceOfFundsValue(store.getState());
    const lumpsum = getLumpsumValue(store.getState());
    const desired = getDesiredValue(store.getState());
    const personalDetailsFormValid = sourceOfFunds && sourceOfFunds.value === 'other' ? validatePersonalDetailsOtherFormDetails(lumpsum,desired,personalDetailsForm) : validatePersonalDetailsFormDetails(lumpsum,desired,personalDetailsForm);

    const formAction = personalDetailsFormValid
        ? transitionDigitalSavingsPersonalDetails.formValid()
        : transitionDigitalSavingsPersonalDetails.formInvalid();
    store.dispatch(formAction);
    return result;
};

const checkForDeclaration  = (lumpsum,desired,formFields) => {
    if(lumpsum.value >= 1000000 || desired.value >= 1000000) {
        return  formFields.sourceOfFundsDetails.status === FIELD_STATUS.VALID && 
            formFields.fundsFromLegitimateSource.value && 
            formFields.informationIsTrueAndCorrect.value && 
            formFields.acceptPrivacyNotice.value ? true : false;
    } else {
        return true;
    }
}

const validatePersonalDetailsFormDetails = (lumpsum,desired,formFields) => {
    if( formFields.idPassport.value === 'passport') {
         return (
        formFields.title && checkForDeclaration(lumpsum,desired,formFields) &&
        formFields.title.status === FIELD_STATUS.VALID &&
        formFields.firstName &&
        formFields.firstName.status === FIELD_STATUS.VALID &&
        formFields.surname &&
        formFields.surname.status === FIELD_STATUS.VALID &&
        formFields.dob &&
        formFields.dob.status === FIELD_STATUS.VALID &&
        formFields.gender &&
        formFields.gender.status === FIELD_STATUS.VALID &&
        formFields.occupation &&
        formFields.occupation.status === FIELD_STATUS.VALID &&
        formFields.nationality &&
        formFields.nationality.status === FIELD_STATUS.VALID &&
        formFields.sourceOfFunds &&
        formFields.sourceOfFunds.status === FIELD_STATUS.VALID && (formFields.sourceOfFunds.value === 'salary' ? (formFields.employerName && formFields.employerName.status === FIELD_STATUS.VALID && formFields.salaryRange.status === FIELD_STATUS.VALID) : true) &&
        formFields.idPassport &&
        formFields.idPassport.status === FIELD_STATUS.VALID &&
        formFields.passportNumber &&
        formFields.passportNumber.status === FIELD_STATUS.VALID &&
        formFields.kraPinNumber &&
        formFields.kraPinNumber.status === FIELD_STATUS.VALID &&
        formFields.mobileNumber &&
        formFields.mobileNumber.status === FIELD_STATUS.VALID &&
        formFields.email &&
        formFields.email.status === FIELD_STATUS.VALID &&
        formFields.fullAddress &&
        formFields.fullAddress.status === FIELD_STATUS.VALID &&
        formFields.postalBox &&
        formFields.postalBox.status === FIELD_STATUS.VALID
    );
    } else {
        return (
            formFields.title && checkForDeclaration(lumpsum,desired,formFields) &&
            formFields.title.status === FIELD_STATUS.VALID &&
            formFields.firstName &&
            formFields.firstName.status === FIELD_STATUS.VALID &&
            formFields.surname &&
            formFields.surname.status === FIELD_STATUS.VALID &&
            formFields.dob &&
            formFields.dob.status === FIELD_STATUS.VALID &&
            formFields.gender &&
            formFields.gender.status === FIELD_STATUS.VALID &&
            formFields.occupation &&
            formFields.occupation.status === FIELD_STATUS.VALID &&
            formFields.nationality &&
            formFields.nationality.status === FIELD_STATUS.VALID &&
            formFields.sourceOfFunds &&
            formFields.sourceOfFunds.status === FIELD_STATUS.VALID && (formFields.sourceOfFunds.value === 'salary' ? (formFields.employerName && formFields.employerName.status === FIELD_STATUS.VALID && formFields.salaryRange.status === FIELD_STATUS.VALID ): true) &&
            formFields.idPassport &&
            formFields.idPassport.status === FIELD_STATUS.VALID &&
            formFields.idNumber &&
            formFields.idNumber.status === FIELD_STATUS.VALID &&
            formFields.kraPinNumber &&
            formFields.kraPinNumber.status === FIELD_STATUS.VALID &&
            formFields.mobileNumber &&
            formFields.mobileNumber.status === FIELD_STATUS.VALID &&
            formFields.email &&
            formFields.email.status === FIELD_STATUS.VALID &&
            formFields.fullAddress &&
            formFields.fullAddress.status === FIELD_STATUS.VALID &&
            formFields.postalBox &&
            formFields.postalBox.status === FIELD_STATUS.VALID
        );
    }
};

const validatePersonalDetailsOtherFormDetails = (lumpsum,desired,formFields) => {
    if( formFields.idPassport.value === 'passport') { 
        return (
            formFields.title && checkForDeclaration(lumpsum,desired,formFields) &&
            formFields.title.status === FIELD_STATUS.VALID &&
            formFields.firstName &&
            formFields.firstName.status === FIELD_STATUS.VALID &&
            formFields.surname &&
            formFields.surname.status === FIELD_STATUS.VALID &&
            formFields.dob &&
            formFields.dob.status === FIELD_STATUS.VALID &&
            formFields.gender &&
            formFields.gender.status === FIELD_STATUS.VALID &&
            formFields.occupation &&
            formFields.occupation.status === FIELD_STATUS.VALID &&
            formFields.nationality &&
            formFields.nationality.status === FIELD_STATUS.VALID &&
            formFields.sourceOfFunds &&
            formFields.sourceOfFunds.status === FIELD_STATUS.VALID &&
            formFields.sourceOfOtherFunds &&
            formFields.sourceOfOtherFunds.status === FIELD_STATUS.VALID &&
            formFields.idPassport &&
            formFields.idPassport.status === FIELD_STATUS.VALID &&
            formFields.passportNumber &&
            formFields.passportNumber.status === FIELD_STATUS.VALID &&
            formFields.kraPinNumber &&
            formFields.kraPinNumber.status === FIELD_STATUS.VALID &&
            formFields.mobileNumber &&
            formFields.mobileNumber.status === FIELD_STATUS.VALID &&
            formFields.email &&
            formFields.email.status === FIELD_STATUS.VALID &&
            formFields.fullAddress &&
            formFields.fullAddress.status === FIELD_STATUS.VALID &&
            formFields.postalBox &&
            formFields.postalBox.status === FIELD_STATUS.VALID
        );
    } else {
        return (
            formFields.title && checkForDeclaration(lumpsum,desired,formFields) &&
            formFields.title.status === FIELD_STATUS.VALID &&
            formFields.firstName &&
            formFields.firstName.status === FIELD_STATUS.VALID &&
            formFields.surname &&
            formFields.surname.status === FIELD_STATUS.VALID &&
            formFields.dob &&
            formFields.dob.status === FIELD_STATUS.VALID &&
            formFields.gender &&
            formFields.gender.status === FIELD_STATUS.VALID &&
            formFields.occupation &&
            formFields.occupation.status === FIELD_STATUS.VALID &&
            formFields.nationality &&
            formFields.nationality.status === FIELD_STATUS.VALID &&
            formFields.sourceOfFunds &&
            formFields.sourceOfFunds.status === FIELD_STATUS.VALID &&
            formFields.sourceOfOtherFunds &&
            formFields.sourceOfOtherFunds.status === FIELD_STATUS.VALID &&
            formFields.idPassport &&
            formFields.idPassport.status === FIELD_STATUS.VALID &&
            formFields.idNumber &&
            formFields.idNumber.status === FIELD_STATUS.VALID &&
            formFields.kraPinNumber &&
            formFields.kraPinNumber.status === FIELD_STATUS.VALID &&
            formFields.mobileNumber &&
            formFields.mobileNumber.status === FIELD_STATUS.VALID &&
            formFields.email &&
            formFields.email.status === FIELD_STATUS.VALID &&
            formFields.fullAddress &&
            formFields.fullAddress.status === FIELD_STATUS.VALID &&
            formFields.postalBox &&
            formFields.postalBox.status === FIELD_STATUS.VALID
        );
    }
};